$(document).on('click', '.js-load-more', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $columnssWrapper = $this.closest('.main__content').find('.cols');
  const $loadMoreButtonWrapper = $this.parent();

  $.ajax({
    url: $this.attr('href'),
    type: 'get',
  })
  .done((data) => {
    const $data = $(data);
    const $itemToAppend = $data.find('.col');
    const $loadButtonWrapper = $data.find('.content__actions');

    $columnssWrapper.append($itemToAppend);
    $loadMoreButtonWrapper.html($loadButtonWrapper);
  })
})

$(window).on('load', function() {
  if ($('.template-blog').length) {
    const $selectedFilters = $('.js-filter-article:checked')

    $selectedFilters.each(function() {
      $(this).closest('.widget').addClass('is-expanded')
    })
  }
})

$('.js-filter-article').on('change', function(event) {
  event.preventDefault();

  const blogUrl = $(this).closest('.js-widgets').data('blog_url');
  const $selectedFilters = $('.js-filter-article:checked')
  let filtersUrl = '';

  $selectedFilters.each(function() {
    const $this = $(this);
    const tag = $this.data('tag');

    filtersUrl += `${tag}+`
  })

  window.location.href = `${blogUrl}/tagged/${filtersUrl}`;
})

$(window).on('load', function() {
  setTimeout(() => {
    if ($('.js-blog-search').length) {
      $('.js-blog-search').attr('name', 'q')
    }
  }, 1000);
})